import React from 'react';
import { CircularProgress, CircularProgressProps } from '@mui/material';

interface ICircularProgress {
  value: number;
  progressProps?: CircularProgressProps['sx'];
  thickness?: number;
  circleColor?: string;
}

const CircularProgressWithValue: React.FC<ICircularProgress> = ({
  value,
  progressProps,
  thickness,
  circleColor,
}) => {
  const size = 30;
  const defaultThickness = thickness || 5;
  const secColor = circleColor || '#d1d1d1';

  const progressSx = {
    ...(progressProps || {}),
    minWidth: '35px',
    minHeight: '35px',
    borderRadius: '50%',
    boxShadow: `inset 0 0 0 ${(defaultThickness / 44) * size}px ${secColor}`,
  };

  return (
    <CircularProgress
      size={size}
      thickness={defaultThickness}
      value={value}
      sx={progressSx}
      variant="determinate"
    />
  );
};

export default CircularProgressWithValue;
